const warn = (message: string, ...args: unknown[]): void => {
    if (typeof console !== 'undefined') console.warn(message, ...args);
};

export {warn};
